import { render, staticRenderFns } from "./sendModal.vue?vue&type=template&id=9aede784&scoped=true&"
import script from "./sendModal.vue?vue&type=script&lang=js&"
export * from "./sendModal.vue?vue&type=script&lang=js&"
import style0 from "./sendModal.vue?vue&type=style&index=0&id=9aede784&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aede784",
  null
  
)

export default component.exports